<template>
  <div>
    <a
      v-if="url!=''"
      :href="url"
      :target="target"
      class="c-link--reset c-link--arrow l-columns-container"
    >
      <svg
        class="l-column--1"
        xmlns="http://www.w3.org/2000/svg"
        width="26.613"
        height="14.581"
        viewBox="0 0 26.613 14.581"
        preserveAspectRatio="xMaxYMid"
      >
        <path
          d="M45.294,40.028l-6.389-6.389a.633.633,0,1,0-.9.9l5.281,5.281H20.036a.639.639,0,0,0,0,1.278h23.3l-5.322,5.324a.617.617,0,0,0,0,.9.639.639,0,0,0,.469.17.649.649,0,0,0,.469-.17l6.389-6.389a.362.362,0,0,0,.128-.213.455.455,0,0,0,.043-.213c0-.043,0-.17-.043-.213-.045-.128-.13-.17-.173-.256Z"
          transform="translate(-19.147 -33.15)"
          stroke-linecap="round"
          stroke-width="0.5"
        />
      </svg>

      <p class="c-link--arrow__text">{{ title }}</p>
      
    </a>

    <div
      v-else
      class="c-link--reset c-link--arrow l-columns-container"
    >
      <svg
        class="l-column--1"
        xmlns="http://www.w3.org/2000/svg"
        width="26.613"
        height="14.581"
        viewBox="0 0 26.613 14.581"
        preserveAspectRatio="xMaxYMid"
      >
        <path
          d="M45.294,40.028l-6.389-6.389a.633.633,0,1,0-.9.9l5.281,5.281H20.036a.639.639,0,0,0,0,1.278h23.3l-5.322,5.324a.617.617,0,0,0,0,.9.639.639,0,0,0,.469.17.649.649,0,0,0,.469-.17l6.389-6.389a.362.362,0,0,0,.128-.213.455.455,0,0,0,.043-.213c0-.043,0-.17-.043-.213-.045-.128-.13-.17-.173-.256Z"
          transform="translate(-19.147 -33.15)"
          stroke-linecap="round"
          stroke-width="0.5"
        />
      </svg>

      <p class="c-link--arrow__text">
        {{ title }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArrowLink",
  props: {
    url: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      arrowRight: false,
      labelLeft: false
    }
  }
};
</script>

<style lang="scss">
@import "../vars.scss";
@import "../mixins.scss";

.c-link--arrow {
  display: flex;
  align-items: center;
  margin-top: 0.5em;
  color: $blue;
  font-family: $ffSubHead;
  will-change: color, transform;
  transition: color 200ms ease-out, transform 150ms ease-in-out;
  @include font-size($font-size-arrow-link);
  text-decoration: none;

  &--left {
    svg {
      transform: rotate(180deg);
    }
  }

  &--right & {
    flex-direction: row-reverse;
  }

  &:hover {
    color: darken($color, 20%);
    transform: translateX(.1em);
  }

  &--left &:hover {
    transform: translateX(-.1em);
  }

  &:last-child {
    margin-bottom: 1em;
  }

  .c-page--blue & {
    color: currentColor;
  }

  &__text {
      margin: 0 0 0 $gutter;
  }

  &--right &__text {
    margin-right: $gutter;
    margin-left: 0;
  }

  svg {
    display: block;
    width: 1.12em;
    height: .7em;
    margin-top: -0.18em;
    stroke: currentColor;
    fill: currentColor;
  }
}
</style>